import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type SelectedMfoOffer = {
  mfoDealId: string;
  offerId: string;
};

export type MfoOfferSelectionState = {
  selectedOffer: SelectedMfoOffer | null;
};

const initialState: MfoOfferSelectionState = {
  selectedOffer: null,
};

const isSameSelectedOffer = (current: SelectedMfoOffer | null, next: SelectedMfoOffer): boolean =>
  current?.mfoDealId === next.mfoDealId && current?.offerId === next.offerId;

export const mfoOfferSelectionSlice = createSlice({
  name: 'mfoOfferSelection',
  initialState,
  reducers: {
    selectMfoOffer: (state, { payload }: PayloadAction<SelectedMfoOffer>) => {
      state.selectedOffer = isSameSelectedOffer(state.selectedOffer, payload) ? null : payload;
    },
    clearSelectedMfoOffer: (state) => {
      state.selectedOffer = null;
    },
  },
});

export const { selectMfoOffer, clearSelectedMfoOffer } = mfoOfferSelectionSlice.actions;
